import { Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { AdditionalInformation } from "../additionalInformation";
import { BookingDetails } from "../bookingDetails";
import { GuestDetails } from "../guestDetails";
import { PaymentDetails } from "../paymentDetails";
import { RoomDetails } from "../roomDetails";

export const BookingModal = (props) => {
  const { selectedBooking, isModalVisible, handleCancel } = props;
  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <InfoCircleOutlined style={{ fontSize: "24px", color: "#1890ff" }} />
          <h2 style={{ margin: 0, color: "#1890ff" }}>
            Booking Details - {selectedBooking.bookingId}
          </h2>
        </div>
      }
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      width={900}
      bodyStyle={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        maxHeight: "70vh",
        overflowY: "auto",
      }}
    >
      <div className="flex-direction-column" style={{ gap: "20px" }}>
        {/* Guest Details Section */}
        <GuestDetails selectedBooking={selectedBooking} />

        {/* Booking Details Section */}
        <BookingDetails selectedBooking={selectedBooking} />

        {/* Room Details Section */}
        <RoomDetails selectedBooking={selectedBooking} />

        {/* Payment Details Section */}
        <PaymentDetails selectedBooking={selectedBooking} />

        {/* Additional Information Section */}
        <AdditionalInformation selectedBooking={selectedBooking} />
      </div>
    </Modal>
  );
};
